module.exports = __webpack_public_path__ + "static/img/yule_voice.0eb992ce.png";